import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { DigitalDepositStackRoutes, DigitalDepositStackScreenProps } from './type';
import { DigitalDepositWebAddressScreen } from './DigitalDepositWebAddress.screen';
import { DigitalDepositNativeAddressScreen } from './DigitalDepositNativeAddress.screen';

export const DigitalDepositAddress: React.FC<DigitalDepositStackScreenProps<DigitalDepositStackRoutes.Address>> = ({
  navigation,
  route
}) => {
  const { onLayout, account, refresh, record, onChangeView } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <DigitalDepositNativeAddressScreen onClose={onGoBack} onLayout={onLayout} account={account} refresh={refresh} record={record} />;
  }

  return (
    <DigitalDepositWebAddressScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      refresh={refresh}
      record={record}
      onChangeView={onChangeView}
    />
  );
};
